export const visit = (vm, at) => {
at({ "it": { "conversations-visitor-experience-components": { "code-splitting": { "error": { "title": "Si \xE8 verificato un problema di connessione di rete.", "message": "Verifica la connessione e riprova.", "button": "Riprova" } } } } });
};